import { render, staticRenderFns } from "./ContractorsIndex.vue?vue&type=template&id=058940e2&"
import script from "./ContractorsIndex.vue?vue&type=script&lang=js&"
export * from "./ContractorsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports